import { MockFactory } from '@tino-frontend/mocks'
import { Situation } from '@types'
import { legalPersonAPIMock } from './legal-person'

export const situationAPIMock = new MockFactory<Situation>({
  background_check_status: 'pending',
  face_match_status: 'pending',
  has_pending_terms_to_sign: false,
  ocr_status: 'pending',
  status: 'sent_documents',
  document_front_photo_status: 'received',
  document_back_photo_status: 'received',
  self_photo_status: 'received',
  has_email_validation: false,
  legal_person_situation: [legalPersonAPIMock.source],
})
